import React from 'react';
import { Section } from './ui/Section';
import { Check, Clock } from 'lucide-react';
const bonuses = [{
  number: '01',
  title: 'Checklist Anti-Humedad (12 puntos)',
  subtitle: 'Mil Hojas A Prueba de Clima',
  promise: 'Tu control de calidad en 5 minutos para evitar el hojaldre "chicloso".',
  bullets: ['12 checks antes/durante/después', 'Versión imprimible + versión móvil', 'Tarjeta de emergencia (rescates rápidos)'],
  value: '$9'
}, {
  number: '02',
  title: 'Guía "Corte Limpio"',
  subtitle: 'Herramientas + Técnica + Porciones Perfectas',
  promise: 'Porciones prolijas sin aplastar capas ni embarrar crema.',
  bullets: ['Técnica Corta–Guía–Limpia', 'Checklist pre-corte', 'Tabla de porciones (6/8/10/12)'],
  value: '$11'
}, {
  number: '03',
  title: 'Kit Solución de Problemas',
  subtitle: 'Diagnóstico Rápido (16 fallas + fixes)',
  promise: 'Identifica la falla y aplica el fix correcto en minutos.',
  bullets: ['Tabla síntoma → causa → fix', 'Árbol de decisión rápido', 'Checklist prevención (7 puntos)'],
  value: '$17'
}];
export function BonusSection() {
  return <Section background="white" id="bonos" data-id="element-21">
      <div className="max-w-5xl mx-auto" data-id="element-22">
        {/* Badge */}
        <div className="flex justify-center mb-6" data-id="element-23">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-100 border border-amber-200 text-amber-800 text-xs font-semibold tracking-wide uppercase" data-id="element-24">
            <Clock className="w-3 h-3" data-id="element-25" />
            Oferta por tiempo limitado
          </span>
        </div>

        {/* Heading */}
        <div className="text-center mb-12" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-3" data-id="element-27">
            Bonos SOLO HOY
            <span className="block text-amber-600 text-2xl md:text-3xl mt-1" data-id="element-28">
              Incluidos sin costo extra
            </span>
          </h2>
          <p className="text-stone-500 text-base max-w-xl mx-auto leading-relaxed" data-id="element-29">
            Si compras hoy, te llevas estos 3 bonos para lograr capas firmes,
            corte limpio y cero estrés al servir.
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10" data-id="element-30">
          {bonuses.map(bonus => <div key={bonus.number} className="bg-[#FDFBF7] border border-stone-200 rounded-2xl p-6 flex flex-col" data-id="element-31">
              {/* Number + value */}
              <div className="flex items-start justify-between mb-4" data-id="element-32">
                <span className="text-xs font-bold text-stone-400 tracking-widest uppercase" data-id="element-33">
                  Bono {bonus.number}
                </span>
                <span className="text-xs font-semibold text-stone-500 bg-stone-100 px-2 py-0.5 rounded-full" data-id="element-34">
                  Valor: {bonus.value}
                </span>
              </div>

              {/* Title */}
              <h3 className="font-serif font-bold text-stone-900 text-base leading-snug mb-1" data-id="element-35">
                {bonus.title}
              </h3>
              <p className="text-xs text-amber-700 font-medium mb-3" data-id="element-36">
                {bonus.subtitle}
              </p>

              {/* Promise */}
              <p className="text-sm text-stone-600 leading-relaxed mb-4 border-l-2 border-amber-300 pl-3" data-id="element-37">
                {bonus.promise}
              </p>

              {/* Bullets */}
              <ul className="space-y-2 mt-auto" data-id="element-38">
                {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-sm text-stone-700" data-id="element-39">
                    <Check className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-40" />
                    {bullet}
                  </li>)}
              </ul>
            </div>)}
        </div>

        {/* Total value line */}
        <div className="text-center" data-id="element-41">
          <p className="text-sm text-stone-500" data-id="element-42">
            Valor total de bonos:{' '}
            <span className="line-through text-stone-400" data-id="element-43">$37</span> —{' '}
            <span className="font-semibold text-stone-900" data-id="element-44">
              Incluidos SOLO HOY.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}